import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Validates process (processo)
*/
export const validatesProcesso = async (processoId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/external/validate?processoId=${processoId}`;
    return await axios.get(url);
}
